function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCombobox } from "downshift";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { Box, Text } from "sprout-ui-primitives";
import { useLocale } from "react-aria";
import { Input } from "../Form";
import { getIsLargePointerDevice } from "../utils";
import DateQueryResult from "./DateQueryResult";
const stateReducer = (state, actionAndChanges)=>{
    const { type , changes  } = actionAndChanges;
    if (type === useCombobox.stateChangeTypes.InputBlur) return state;
    if (type === useCombobox.stateChangeTypes.InputKeyDownEnter) return _objectSpread({}, changes, {
        inputValue: state.inputValue
    });
    if (type === useCombobox.stateChangeTypes.InputChange) return _objectSpread({}, changes, {
        highlightedIndex: 0
    });
    return changes;
};
const DateQuery = (props)=>{
    const { onSelected , onChange , onEscape , items , onQuery , initialHighlightedIndex , hidePristineTitle ,  } = props;
    const { locale  } = useLocale();
    const handleInputValueChange = useCallback((args)=>{
        const { inputValue  } = args;
        if (onQuery) onQuery(inputValue);
        onChange(args);
    }, [
        onChange,
        onQuery
    ]);
    const handleSelectedItemChange = useCallback((changes)=>{
        const { selectedItem  } = changes;
        if (selectedItem) onSelected(selectedItem);
    }, [
        onSelected
    ]);
    const { getInputProps , getComboboxProps , getMenuProps , inputValue: inputValue1 , getItemProps ,  } = useCombobox({
        initialHighlightedIndex,
        items,
        onInputValueChange: handleInputValueChange,
        stateReducer,
        itemToString: useMemo(()=>()=>"", []),
        onSelectedItemChange: handleSelectedItemChange
    });
    const inputRef = useRef(null);
    useEffect(()=>{
        if (inputRef.current && getIsLargePointerDevice()) inputRef.current.focus();
    }, []);
    const handleKeyDown = useCallback((event)=>{
        if (event.key === "Escape" && onEscape) onEscape();
    }, [
        onEscape
    ]);
    return /*#__PURE__*/ _jsxs(Box, _objectSpread({}, getComboboxProps(), {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                pb: 2,
                children: /*#__PURE__*/ _jsx(Input, _objectSpread({
                    placeholder: "Type when..."
                }, getInputProps({
                    onKeyDown: handleKeyDown,
                    ref: inputRef
                })))
            }),
            inputValue1.length === 0 && !hidePristineTitle && /*#__PURE__*/ _jsx(Text, {
                color: "blue.40",
                caps: true,
                fontWeight: "bold",
                fontSize: 1,
                p: 1,
                children: "Choose When..."
            }),
            /*#__PURE__*/ _jsx(Box, _objectSpread({}, getMenuProps(), {
                children: items.map((item, index)=>{
                    return /*#__PURE__*/ _jsx(DateQueryResult, _objectSpread({
                        date: item,
                        locale: locale
                    }, getItemProps({
                        item,
                        index
                    })), item.toString());
                })
            }))
        ]
    }));
};
export default DateQuery;
